export const homegroups = [
  { value: "", label: "Select your home group" },
  { value: "share_and_care_group", label: "Share & Care Group" },
  { value: "there_is_a_solution", label: "There Is A Solution" },
  { value: "kitchen_table", label: "Kitchen Table" },
  { value: "sun_up", label: "Sun-Up" },
  { value: "serenity_group", label: "Serenity Group" },
  { value: "a_vision_for_you", label: "A Vision for You" },
  {
    value: "aa_no_rules_no_drama",
    label: "AA No Rules No Drama Just The Primary Purpose",
  },
  { value: "abbeville_area_group", label: "Abbeville Area Group" },
  { value: "any_lengths", label: "Any Lengths" },
  { value: "brown_baggers_group", label: "Brown Baggers Group" },
  { value: "primary_purpose", label: "Primary Purpose" },
  { value: "primary_purpose_beginners", label: "Primary Purpose - Beginners" },
  { value: "sisters_in_sobriety", label: "Sisters In Sobriety" },
  { value: "back_to_basics_group", label: "Back to Basics Group" },
  { value: "new_way_group_of_aa", label: "New Way Group Of AA" },
  { value: "the_bayou_bunch", label: "The Bayou Bunch" },
  { value: "a_design_for_living", label: "A Design for Living" },
  { value: "circle_triangle_group", label: "Circle Triangle Group" },
  { value: "franklin_group", label: "Franklin Group" },
  { value: "ladies_night", label: "Ladies Night" },
  { value: "the_rayne_group", label: "The Rayne Group" },
  { value: "ties_that_bind_group", label: "Ties That Bind Group" },
  { value: "across_the_tracks_group", label: "Across the Tracks Group" },
  { value: "hub_city", label: "Hub City" },
  { value: "old_timers", label: "Old Timers" },
  { value: "experience_strength_hope", label: "Experience Strength & Hope" },
];
